"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEXT_BUTTON_TYPES = void 0;
var TEXT_BUTTON_TYPES = Object.freeze({
  primary: 'primary',
  secondary: 'secondary',
  tertiary: 'tertiary'
});
exports.TEXT_BUTTON_TYPES = TEXT_BUTTON_TYPES;